export enum LAYOUTS_TYPE {
    all = 'ALL',
    navbar = 'NAVBAR',
    footer = 'FOOTER',
    alertInfo = 'INFO',
    alertSucess = 'SUCCESS',
    alertFailure = 'FAILURE',
    notification = 'NOTIFICATION'
}